import { useLinkClickHandler } from 'react-router-dom';
import { DetailPageDto } from '@asset-metrix/portal-gateway-client-js';
import { DetailPageCellRenderer } from '@asset-metrix/portal-ui';
import { ICellRendererParams } from 'ag-grid-community';

import { NO_ROLE_ID } from '../../api/portalGatewayClient';
import { useStore } from '../../store';
import { Filter } from '../../store/states/filterTypes';

import { getDetailPageUrl } from './getDetailPageUrl';
import { useOriginHrefForDetailsPage } from './useOriginHrefForDetailsPage';

export type DetailPageCellRendererContainerProps = ICellRendererParams<
  Record<string, unknown>
> & {
  detailPageConfig?: DetailPageDto;
  pageFilter?: Filter;
};

export function DetailPageCellRendererContainer({
  detailPageConfig,
  pageFilter,
  ...props
}: DetailPageCellRendererContainerProps) {
  const { data, value, valueFormatted } = props;
  const originHref = useOriginHrefForDetailsPage();
  const roleId = useStore((state) => state.activeUserRole?.id);

  const completeHref =
    detailPageConfig &&
    getDetailPageUrl(
      roleId ?? NO_ROLE_ID,
      detailPageConfig,
      pageFilter,
      data != null ? [data] : [],
      valueFormatted ?? value
    );

  // set up click handler
  const clickHandler = useLinkClickHandler<HTMLDivElement>(completeHref ?? '', {
    state: {
      originHref,
    },
  });

  return (
    <DetailPageCellRenderer
      onClick={detailPageConfig ? clickHandler : undefined}
      {...props}
    />
  );
}
